import React from "react";
import { mq, scrollTo } from "../util";
import Arrow from "@assets/svgs/arrow-down.svg";

const NextTrigger = ({ target }) => (
  <div css={mq({ padding: ["100px 0"], textAlign: "center" })}>
    <button type="button" onClick={() => scrollTo(target)}>
      <Arrow />
    </button>
  </div>
);

export default NextTrigger;
